import { SuggestedFaqStatus } from '@/models/suggestedFaq.model';

export type TSuggestedFaqFilters = {
  question?: string;
  answer?: string;
  channelId?: number;
  status?: SuggestedFaqStatus;
};

export const parseSuggestedFaqFilters = (params: URLSearchParams): TSuggestedFaqFilters => ({
  question: params.get('question') || undefined,
  answer: params.get('answer') || undefined,
  channelId: params.get('channelId') ? Number(params.get('channelId')) : undefined,
  status: (params.get('status') as SuggestedFaqStatus) || undefined,
});
